import { localizeUrl } from 'helpers/locales';

import { logout, updateHeaders } from 'store/modules/auth';

import { addApiInterceptor, setApiRequestHeaders } from 'api';

const signInPathRegex = /\/api\/v1\/auth\/sign_in/;

const setupHeadersInterceptor = ({ authHeaders, dispatch, history }) => {
  addApiInterceptor(
    (response) => {
      dispatch(updateHeaders(response));
      setApiRequestHeaders(response.headers);
    },
    ({ request, response }) => {
      if (!response) {
        return;
      }

      if (
        !signInPathRegex.test(request.responseURL) &&
        !response.config.noRedirect && response.status === 401
      ) {
        dispatch(logout({ invalidateToken: false }));

        const currentPath = window.location.pathname;

        const localizeSignIn = localizeUrl(currentPath, '/sign-in');

        history.push({
          pathname: localizeSignIn,
          state: {
            backTo: currentPath,
          },
        });
      }
    },
  );

  setApiRequestHeaders(authHeaders);
};

export default setupHeadersInterceptor;
